import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

type SenderCountBadgeProps = {
	/** Distinct users with at least one active sender. */
	selected: number;
	/** Distinct users available to select. */
	total: number;
	/** Whether the tab this badge sits on is currently active (drives its colors). */
	active?: boolean;
};

/**
 * Compact "selected / total" pill for the Senders tab — counts distinct sending
 * users (channel-agnostic). Tints to the brand color on the active tab and stays
 * neutral otherwise. Renders nothing when there are no users to select.
 */
export const SenderCountBadge: FunctionComponent<SenderCountBadgeProps> = ({
	selected,
	total,
	active = false,
}) => {
	if (total === 0) {
		return null;
	}

	return (
		<span
			className={classNames(
				"ml-2 inline-flex items-center justify-center rounded-full px-2 py-0.5 text-xs font-semibold leading-none tabular-nums transition-colors duration-200",
				active ? "bg-brand-light/10 text-brand-light" : "bg-gray-100 text-text-meta"
			)}
		>
			{selected}/{total}
		</span>
	);
};
